// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "._2hQHuHxNQAe6bpyrLYqtMb{width:100%;height:60vh;line-height:60vh;text-align:center;color:#666}\n", "",{"version":3,"sources":["webpack://src/client/pages/me/components/list-empty/style.module.scss"],"names":[],"mappings":"AAEA,yBACI,UAAW,CACX,WAAY,CACZ,gBAAiB,CACjB,iBAAkB,CAClB,UAAW","sourcesContent":["@import '../../../../base.scss';\n\n.ListEmpty{\n    width: 100%;\n    height: 60vh;\n    line-height: 60vh;\n    text-align: center;\n    color: #666;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"ListEmpty": "_2hQHuHxNQAe6bpyrLYqtMb"
};
module.exports = ___CSS_LOADER_EXPORT___;
